import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-commissions-table',
  templateUrl: './commissions-table.component.html',
  styleUrls: ['./commissions-table.component.scss']
})
export class CommissionsTableComponent {
  @Input() listPayments:any[] = [];

}
